export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
        <p>
          &copy; 2025 Datageek. Todos los derechos reservados.{' '}
          <a href='/reclamaciones' rel='nofollow'>Libro de Reclamaciones</a>
        </p>
        </div>
      </div>
    </div>
  )
}
